import AppRecord from './AppRecord.js'

class DepositReconciliationHistory extends AppRecord {
  get deposit(){
    if (this.cachedDeposit == null) {
      this.cachedDeposit = this.constructor.employeeStore.deposits.find(deposit => deposit.id === Number(this.deposit_id))
    }

    return this.cachedDeposit
  }
  get entity(){
    if (this.cachedEntity == null) {
      this.cachedEntity = this.constructor.employeeStore.entitiesById.get(Number(this.entity_id))
    }

    return this.cachedEntity
  }

  get bankName(){
    if (this.cachedBankName == null) {
      this.cachedBankName = this.constructor.employeeStore.banks.find(bank => bank.id === this.bank_id)?.name
    }

    return this.cachedBankName
  }

  get issueName(){
    if (this.cachedIssueName == null) {
      this.cachedIssueName = this.constructor.employeeStore.issues.find(issue => issue.id === this.issue_id)?.name
    }

    return this.cachedIssueName
  }

  get user(){
    if (this.cachedUser == null) {
      this.cachedUser = this.constructor.employeeStore.users.find(user => user.id === Number(this.created_by_user_id))
    }

    return this.cachedUser
  }
}
export default DepositReconciliationHistory
